(function () {
  //const lang = document.documentElement.lang || '';
  //if (!lang.toLowerCase().startsWith('en')) return;
  
  if (window.__jintaStarsLoaded) return;
  window.__jintaStarsLoaded = true;

  function fixJudgeMeStars(scope) {
    const root = scope || document;

    root.querySelectorAll('.jdgm-star:not(.jinta-star-fixed), .jm-star-rating__font-icon:not(.jinta-star-fixed)').forEach(function (el) {
      var content = (el.textContent || '').trim();
      var brokenIcon = /[\uE000-\uF8FF]/.test(content);
      var emptyJudgeStar = el.classList.contains('jdgm-star') && content === '';

      if (!brokenIcon && !emptyJudgeStar) return;

      el.classList.add('jinta-star-fixed');

      var isEmpty = el.classList.contains('jdgm--off');

      el.innerHTML =
        '<svg viewBox="0 0 24 24" class="jinta-jdgm-star-svg' +
        (isEmpty ? ' jinta-jdgm-star-svg--empty' : '') +
        '" aria-hidden="true"><path d="M12 2.6l2.9 6 6.6.95-4.75 4.65 1.12 6.55L12 17.65 6.13 20.75l1.12-6.55L2.5 9.55 9.1 8.6 12 2.6z"/></svg>';
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    fixJudgeMeStars(document);

    setTimeout(function () {
      fixJudgeMeStars(document);
    }, 800);
  });

  window.addEventListener('load', function () {
    const grid =
      document.querySelector('#ProductGridContainer') ||
      document.querySelector('#product-grid') ||
      document.querySelector('.product-grid') ||
      document.querySelector('.product__info-container');

    if (!grid) return;

    const observer = new MutationObserver(function (mutations) {
      clearTimeout(window.__jintaJdgmFix);

      window.__jintaJdgmFix = setTimeout(function () {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) {
              fixJudgeMeStars(node);
            }
          });
        });
      }, 250);
    });

    observer.observe(grid, {
      childList: true
    });
  });
})();